import { getI18n } from 'src/i18n/i18n.middleware'
import { createHydratingClientLoader } from 'src/utils/ssr'
import { SITE_NAME, staticMeta, staticMetaLoader } from 'src/utils/ssr-meta/seo'
import type { Route } from './+types/_app.my2025'

const getClientModule = () => import('src/clientRoutes/_app.my2025')

export const handle = { name: '__year-recap' }

/** SSR loader. Source: https://github.com/troph-team/pixai/blob/main/packages/pixai-server/src/ssr/router.ts#L494-L514 */
export function loader({ request, context }: Route.LoaderArgs) {
  const { t, exists } = getI18n(context)

  const titleKey = 'yearrecap:label'
  const descKey = 'yearrecap:2025.banners.daily-claim-bottom.label'
  const imageKey = 'yearrecap:2025.og.image'

  const title = exists(titleKey) ? t(titleKey) : 'Year Recap'
  return staticMetaLoader({
    requestUrl: request.url,
    title: `${title} | ${SITE_NAME}`,
    description: exists(descKey) ? t(descKey) : '',
    image: exists(imageKey) ? t(imageKey) : undefined,
  })
}

/** Meta function for SSR SEO. */
export function meta({ loaderData }: Route.MetaArgs) {
  return staticMeta(loaderData)
}

export const clientLoader =
  createHydratingClientLoader<Awaited<ReturnType<typeof loader>>>(
    getClientModule,
  )

export default function Page() {
  return null
}
